<ng-container *ngIf="updatePassword">
  <div class="main-login-container">
    <!-- <div class="shape shape-01">
      <img src="./assets/images/auth-shape-01.svg" alt="" />
    </div>
    <div class="shape shape-02">
      <img src="./assets/images/auth-shape-02.svg" alt="" />
    </div> -->
    <div class="login-left-content d-none d-lg-flex">
      <div class="logo">
        <img src="./assets/images/logo-on-light.svg" alt="" />
      </div>
      <div class="auth-isometric">
        <img src="./assets/images/isometric-password.svg" class="img-fluid" alt="" />
      </div>
    </div>
    <div class="login-right-content">
      <div class="login-content">
        <div class="text-content has-back-button">
          <button mat-fab color="primary" (click)="logout()" class="shadow-none mb-4">
            <mat-icon> arrow_back </mat-icon>
          </button>

          <h1 class="title">
            Update Password
          </h1>
        </div>
        <form [formGroup]="forgotPasswordForm">
          <div class="form-group">
            <mat-form-field appearance="outline" class="change-password-field-hint-height mb-1">
              <mat-label>New Password</mat-label>
              <input
                matInput
                [type]="hide ? 'password' : 'text'"
                formControlName="password"
                (keypress)="notAllowSpace($event)"
              />
              <button mat-icon-button matSuffix (click)="hide = !hide">
                <mat-icon>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
              </button>
              <mat-hint slot="start" class="text-danger" *ngIf="forgotPasswordForm.get('password')?.hasError('invalidPassword')">The password you entered doesn't meet the minimum security requirements.</mat-hint>
            </mat-form-field>
            <p class="hint-text"> <small>Password should be 11 to 50 characters with at least 1 Upper Case, 1 Lower Case, 1 Special and 1 Numeric Character. Should not be Previous 3 Passwords.</small></p>
          </div>
          <div class="buttons d-grid">
            <button
              mat-raised-button
              color="primary"
              [disabled]="forgotPasswordForm.invalid"
              (click)="onsubmit()"
            >
              Submit
            </button>

            <!-- <button  mat-raised-button (click)="logout()">Back</button> -->
          </div>
        </form>
      </div>
    </div>
  </div>
</ng-container>

<div class="verification-alert" *ngIf="verifyEmail">
  <img src="./assets/images/email.svg" class="img-fluid" alt="" />
  <h2>Email not Verified</h2>
  <p>You need to verify your email to access the application.</p>
</div>